import { CardFooterContent, CardBonuses } from './CardOverlay';
import Amount from './Amount';
import { useImages } from '../context/ImageContext';
const { Overlay } = require('react-bootstrap');
const { GetCardColor } = require('./Utilities/Utilities');
const { CardBenefit } = require('@tta/engine/Utilities/CardBenefits');
const { ShownName } = require('@tta/engine/Utilities/ShownNames');

// What each worker on the card gives, with what the player's other cards add to it (e.g. Darwin's +1 culture on a
// library): the card's own bonuses, changed; null when nothing changes them
const WithPerWorker = (card, perWorker) => {
    const benefit = CardBenefit(card);
    if (!benefit?.perWorker || perWorker.length === 0)
    {
        return null;
    }
    const bonuses = { ...benefit.bonuses };
    perWorker.forEach(effect => { bonuses[effect.stat] = (bonuses[effect.stat] ?? 0) + effect.value; });
    return Object.fromEntries(Object.entries(bonuses).filter(([, value]) => value !== 0));
};

// A card on a player's board, on hover: small, like a card in the row (its color top and bottom), with its name, what
// it costs to build and what each worker on it gives. note: a line under it, e.g. why it can't be picked right now.
// With the player's other cards' changes to these (see TechnologyViewModel), as the final amounts only: cost, its cost
// after their discounts (null when unchanged, green when lower); perWorker, what they add for each worker on it
// ([{ source, stat, value }]); changedBy, those cards ([{ source, image }]), as tiny pictures in the corner
function BoardCardTip({card, target, show, note, cost: adjusted = null, perWorker = [], changedBy = []})
{
    const { images } = useImages();
    const color = GetCardColor(card);
    const cost = adjusted ?? card.Technology?.workerCost;
    const lowered = adjusted !== null && adjusted < card.Technology?.workerCost;
    const bonuses = WithPerWorker(card, perWorker);
    return (
        <Overlay show={show} target={target} placement="top" flip popperConfig={{ strategy: 'fixed' }}>
            {({ arrowProps, hasDoneInitialMeasure, popper, placement, show: _, ...props }) =>
                <div {...props} className="tta-board-tip" style={{ ...props.style, borderColor: color }}>
                    <div className="tta-board-tip-band" style={{ backgroundColor: color }}>{card.age.slice(4)}</div>
                    {changedBy.length > 0 &&
                        <div className="tta-board-tip-sources">
                            {changedBy.map(by => images?.[by.image]
                                ? <img key={by.source} src={images[by.image].src} alt={ShownName(by.source)} title={ShownName(by.source)}/>
                                : <span key={by.source} title={ShownName(by.source)}>{by.source.charAt(0)}</span>)}
                        </div>}
                    <div className="tta-board-tip-body">
                        <div className="tta-board-tip-name">{ShownName(card.name)}</div>
                        {cost !== null && cost !== undefined && <div>Cost: <Amount value={cost} kind="resources" numberClass={lowered ? 'tta-cost-lowered' : undefined}/></div>}
                        <div>{bonuses
                            ? <div className="tta-card-benefit" title="What each worker on it gives"><CardBonuses card={{ bonuses }} images={images}/></div>
                            : <CardFooterContent card={card} images={images}/>}</div>
                        {note && <div className="tta-board-tip-note">{note}</div>}
                    </div>
                    <div className="tta-board-tip-band" style={{ backgroundColor: color }}/>
                </div>}
        </Overlay>
    );
}

export default BoardCardTip;
